import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../core/modules/common/tools/noop';

const AllSelector = ({
  className = '',
  onSelectAll = noop,
  onDeSelectAll = noop,
}) => (
  <span className={className}>
    Select:
    <button
      className="highlighted-component all"
      onClick={onSelectAll}
      type="button"
    >all
    </button>/
    <button
      className="highlighted-component none"
      onClick={onDeSelectAll}
      type="button"
    >none
    </button>
  </span>);

export default AllSelector;

AllSelector.propTypes = {
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  className: PropTypes.string,
};
